import Layout from "@/components/feature/Layout";
import ReviewsHeader from "./components/ReviewsHeader";
import ReviewList from "./components/ReviewList";

function Reviews() {
  return (
    <Layout>
      <title>嘿咻嘿咻漫画读者评价 - 口碑、评分与讨论精选</title>
      <meta
        name="description"
        content="嘿咻嘿咻漫画读者评价与讨论精选：综合评分 9.1，涵盖结局考据、人物与治愈向的多样口碑，看看读者们如何评价这部作品。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画评价,嘿咻嘿咻漫画评分,读者讨论,读者口碑"
      />
      <link rel="canonical" href="https://characterz2.github.io/reviews" />

      <ReviewsHeader />
      <ReviewList />
    </Layout>
  );
}

export default Reviews;